<template>
  <div class="wgtSettings">
    <div class="cardR">
      <div class="boxR">
        <div class="fc myZoomClass" id="fancySnap">
          <div class="modal-content filterHolder mdl mdbox" v-show="settingPopShow">
            <div class="modal-header">
              <h5 class="modal-title">Select Filter Levels</h5>
              <div class="close-container myfaBtn" data-dismiss="modal" aria-label="Close"
                v-on:click="settingPopShow = !settingPopShow;">
                <div class="leftright"></div>
                <div class="rightleft"></div>
              </div>
            </div>
            <div class="modal-body">
              <div class="col-12 filterModbx">
                <div class="row mr15top" v-for="(addFilters) in sankeylevel" :key="addFilters">
                  <div class="col-12">
                    <VueMultiselect class="mymultiselect  hide-on-presentation " openDirection="bottom" v-model="addFilters.filterval"
                      :options="getdropsdata" :multiple="false" :allow-empty="false" deselect-label="can't Deselect"
                      :close-on-select="true" placeholder="Pick" track-by="name" label="name" selectLabel="" />
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <div class="effect btn-apply eff-md" v-on:click="getSankeyView(1)">
                Apply
              </div>
            </div>
          </div>
          <div id="sankeyFancyChartDiv">

            <div class="content-panel1" v-show="!IsSankeyErr && !isSankeyData">
              <div class="insideL  hide-on-presentation ">
                <div class="icon">
                  <font-awesome-icon icon="fa-solid fa-bars" />
                </div>
                <div class="contents">
                  <span v-show="!IsSankeyErr">
                    <font-awesome-icon icon="fa-solid fa-cog" title="Open Settings"
                      v-on:click="settingPopShow = !settingPopShow;" />
                    <font-awesome-icon icon="fa-solid fa-chalkboard-teacher" title="Add to Storyboard"
                      v-on:click="addToSlider()" />
                    <font-awesome-icon icon="fa-solid fa-file-download" title="Download Widget"
                      v-on:click="downloadDom()" />
                  </span>
                </div>
              </div>
              <div class="insideR hide-on-presentation">
                <div class="icon">
                  <font-awesome-icon icon="fa-solid fa-info" />
                </div>
                <div class="contents">
                  {{ $parent.widgetInfo.cust_sankey }} <br />
                  <br />
                  Actions you can take on this widget: <br />
                  <ul>
                    <li>Click on
                      <font-awesome-icon class="actIcon" icon="fa-solid fa-cog" /> to open
                      settings
                    </li>
                    <li>Click on
                      <font-awesome-icon class="actIcon" icon="fa-solid fa-chalkboard-teacher" />
                      to add to
                      storyboard
                    </li>
                    <li>Click on
                      <font-awesome-icon class="actIcon" icon="fa-solid fa-file-download" /> to
                      download the chart
                      with current insight
                    </li>
                  </ul>
                </div>
              </div>
              <div v-show="issankeyLoaded">
                <widgetLoadingComp></widgetLoadingComp>
              </div>
              <div class="row">
                <div class="col-10">
                  <h2 class="chartTitle hide-on-presentation themeclr2">{{ fancyChartName }}</h2>
                </div>
                <div class="col-2">
                  <font-awesome-icon icon="fa-solid fa-cog" title="Open Settings" class="myfaBtn cursor-pointer"
                    v-on:click="settingPopShow = !settingPopShow;" />
                </div>
              </div>
              <div v-show="settingPopShow" class="settingDiv"></div>
              <div class="panel-body text-center panelbodyDiy" id="myPanelFCBody" :class="{ 'BlurClass': issankeyLoaded }"
                :style="panelHt">

                <div id="chart-container" style="height: 180vh;"></div>
              </div>
            </div>
            <div class="content-panel1" v-show="IsSankeyErr || isSankeyData">
              <apiErrorComponent @tryReload="tryReload" compTitle="" compId="sankeyFancyChartDiv">
              </apiErrorComponent>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  useRoute
} from 'vue-router';
import widgetLoadingComp from '../smallcomp/widgetloader.vue'
import domtoimage from "dom-to-image-more";
import screenShotMix from "./../../mixin/screenShotMix";
import apiErrorComponent from '../smallcomp/apierror.vue';
import {
  saveAs
} from 'file-saver';
import * as echarts from 'echarts';

var sankeyData

export default {
  name: 'SankeyView',
  mixins: [screenShotMix],
  props: {
    getPins: Object,
    getDrops: Array,
    tabname: String,
  },
  components: {
    widgetLoadingComp,
    apiErrorComponent,
  },
  data() {
    return {
      IsSankeyErr: false,
      isSankeyData: false,
      issankeyLoaded: false,
      fancyChartName: "",
      sankeylevel: [],
      getdropsdata: this.getDrops,
      settingPopShow: false,
      panelHt: "",
      showSan: true
    }
  },
  methods: {
    tryReload() {
      this.getSankeyView(0)
    },
    addToSlider() {
      let insArr = [];
      let name = "Sankey - " + this.getPins.viewName;
      let screenShort = {
        id: 'sankeyFancyChartDiv',
        name: 'sankeyFancyChartDiv.png'
      }
      this.addToSliderMix(screenShort, insArr, name)
    },
    drawSankey() {
      this.showSan = true;

      var chartDom = document.getElementById('chart-container');
      if(chartDom == null) return;
      if (chartDom != null && chartDom != undefined) {
        var myChart = echarts.init(chartDom, null, {
          renderer: 'svg',
          useDirtyRect: false
        });
        var option;
        myChart.showLoading();
        myChart.hideLoading();
        myChart.setOption(
          (option = {
            tooltip: {
              confine: true,
              trigger: 'item',
              triggerOn: 'mousemove'
            },
            series: [{
              type: 'sankey',
              data: sankeyData.nodes,
              links: sankeyData.links,
              emphasis: {
                focus: 'adjacency'
              },
              lineStyle: {
                color: 'gradient',
                curveness: 0.5
              }
            }]
          })
        );

      }
    },
    downloadDom() {
      let imgname = "Sankey_View.png"
      let widgetID = "sankeyFancyChartDiv"
      var geticondiv = document.querySelectorAll(
        '#sankeyFancyChartDiv .insideL,#sankeyFancyChartDiv .insideR, .hide-on-presentation')
      geticondiv.forEach(box => {
        box.style.opacity = 0;
      });
      document.getElementById(widgetID).classList.remove("myZoomClass")
      domtoimage.toBlob(document.getElementById(widgetID))
        .then(function (blob) {
          saveAs(blob, imgname)
          geticondiv.forEach(box => {
            box.style.opacity = 1;
          });
          document.getElementById(widgetID).classList.add("myZoomClass")
        })
    },
    modifylevel(pos, vals) {
      if (vals == 0) {
        this.sankeylevel.splice(pos, 1)
      } else {
        if (pos < 2) {
          this.sankeylevel.push({
            opts: ""
          })
        } else {
          this.$notify({
            type: "error",
            text: 'Sorry! Filter limit Reached!'
          })
        }
      }
    },
    checkDuplicate(arr) {
      for (let i = 0; i < arr.length; i++) {
        for (let j = 1; j < arr.length; j++) {
          if (i !== j) {
            if (arr[i].filterval.dbname == arr[j].filterval.dbname) {
              return true
            }
          }
        }
      }
      return false
    },
    getSankeyView(isfilter) {
      if (isfilter == 1) {
        var dupsChk = this.checkDuplicate(this.sankeylevel)
      }
      if (dupsChk == true) {
        this.$notify({
          type: "error",
          text: 'Sorry! Filter values cannot contain Same values. Try with different filters!'
        })
      } else {
        this.IsSankeyErr = false
        this.isSankeyData = false
        this.fancyChartName = "Sankey View"
        if (this.sankeylevel.length != 3 && isfilter == 1) {
          this.$notify({
            type: "warn",
            text: 'Sorry! Minimum of Three filters should be needed to process Sankey view!'
          })
        } else {
          this.issankeyLoaded = true
          this.axios.post(this.uriApiUrl + 'DataAnalysis/sankey_view?asg_id=' + this.asgId, {
            "filterlevel": this.sankeylevel,
            "selid": this.getPins.selid,
            "edited": this.getPins.edited
          },{
      headers: {
            'Content-Type': 'application/json'
          }})
            .then((response) => {
              if (response.status == 200) {
                if (response.data == "Error") {
                  this.issankeyLoaded = false
                  this.IsSankeyErr = true
                  this.$notify({
                    type: "error",
                    text: 'Sorry! Something went wrong in SunBurst view. Try after sometime!'
                  })
                } else {
                  var respdata = response.data.sankeydata
                  if (respdata != "Error" && respdata != "Nodata") {
                    var sankeywhole = response.data
                    sankeyData = sankeywhole.sankeydata
                    this.sankeylevel = []
                    for (let index = 0; index < sankeywhole.filterlvl.length; index++) {
                      this.sankeylevel.push({
                        filterval: sankeywhole.filterlvl[index]
                      })
                    }
                    if (isfilter == 1) {
                      this.settingPopShow = !this.settingPopShow
                    }
                    setTimeout(() => {
                      this.drawSankey(this.isRemoveBlank)
                    }, 20)
                  } else if (response.data == "Nodata") {
                    this.isSankeyData = true
                    this.sankeylevel = response.data.filterlvl
                  } else {
                    this.IsSankeyErr = true
                    this.sankeylevel = response.data.filterlvl
                    this.$notify({
                      type: "error",
                      text: 'Sorry! Something went wrong in Sankey view. Try after sometime!'
                    })
                  }
                  this.issankeyLoaded = false
                }
              }
            }).catch((response) => {
              this.IsSankeyErr = true
              this.issankeyLoaded = false
              if (this.enabledDebug == 1) {
                this.$notify({
                  type: "error",
                  text: 'Sorry! Something went wrong in Sankey view. Try after sometime!'
                })
              }
            })
        }
      }
    }
  },
  mounted() {
    const route = useRoute()
    this.asgId = route.params.asgid
    this.getSankeyView(0)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.filterHolder {
  z-index: 30;
  width: 80%;
  left: 10%;
  top: 35px;
}

.wgtSettings {
  min-height: 200vh;
}

.wgtSettings .cardR {
  min-height: 920px;
  width: 100%;
  margin: 0 auto;
}

.wgtSettings .cardR .content-panel1 {
  height: 200vh;
  padding: 10px;
}

.myfaBtn {
  height: 25px;
  width: 25px;
  padding: 5px;
  border-radius: 5px;
}
.darkTheme .modal-content {
  color: #dddddd !important;
}
</style>